/**
 * @generated SignedSource<<1d65a34d1f33c5786495fb063fd4c024>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StageAttachmentInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type stageAttachmentMutation$variables = {
  input: StageAttachmentInput;
};
export type stageAttachmentMutation$data = {
  readonly stageAttachment: {
    readonly clientMutationId: string | null;
    readonly storageKey: string;
    readonly filename: string;
    readonly contentType: string;
    readonly sizeBytes: number;
  } | null;
};
export type stageAttachmentMutation = {
  variables: stageAttachmentMutation$variables;
  response: stageAttachmentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StageAttachmentPayload",
    "kind": "LinkedField",
    "name": "stageAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storageKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sizeBytes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stageAttachmentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stageAttachmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8f45ee036a1ca160f43df2e0eb82963d",
    "id": null,
    "metadata": {},
    "name": "stageAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation stageAttachmentMutation(\n  $input: StageAttachmentInput!\n) {\n  stageAttachment(input: $input) {\n    clientMutationId\n    storageKey\n    filename\n    contentType\n    sizeBytes\n  }\n}\n"
  }
};
})();

(node as any).hash = "253dc0736d52de5dbf820f08be14dba1";

export default node;
